import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Card, message, Popover, Progress, Radio, Upload} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import {pointsConfig} from './PointsConfig'
import {HEADER_HEIGHT} from "../../../constants";
import $ from "jquery";



export default class PointsRule  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            dataSource:[],//配置项
            data:[],
            current:{}
        }
    }

    componentWillMount() {
    }
    componentDidMount() {
         this.getData();

         this.state.dataSource = pointsConfig.dataSource;
         this.setState({})
    }


    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT -32;
        let {dataSource,data} = this.state;
        return(
            <div style={{
                background: '#ffffff',
                padding: '0 15px',
                margin: "15px 0 15px 15px",
                height: height,
                position: 'relative',
                borderRadius:5
            }} id={'point'}>
                <div style={{display:'flex',justifyContent: "space-between",flexWrap: "wrap",}}>
                    {dataSource.map((item,index)=>{
                        return <Card title={item.text} key={index} extra={<a onClick={()=>{
                            this.edit()
                        }}>保存</a>} style={{ width: "33%",height:'370px',marginTop:"30px"}}>{
                            item.inputs.map((componentItem, _index) => {
                                let ItemComponent = null;
                                try {
                                    ItemComponent = require(`../../../view/sysManagement/selectedTopicManagement/formContent/${componentItem.component}.js`).default;
                                } catch (e) {
                                    return <></>
                                }
                                let {field, type,} = componentItem.props;
                                let text ='';
                                data.forEach((i,ids)=>{
                                    if(i.type === type){
                                        text =i[field]
                                    }
                                });
                                return (
                                    <ItemComponent ref={inputComponent => this.pushInputComponent(inputComponent)}
                                                   key={index + "_" + _index} {...componentItem.props}
                                                   itemValue={text}
                                                   callBack={(value) => {
                                                       if (field) {
                                                           data.forEach((i,ids)=>{
                                                               if(i.type === type){
                                                                   i[field]= value
                                                               }
                                                           });
                                                           this.setState({}, () => {
                                                           })
                                                       }
                                                   }}/>
                                )})}
                            <style>{`
                                #point .ant-form-item-label{
                                    width: 87px;
                                    vertical-align: top
                                }
                                #point .ant-form-item {
                                    margin-bottom: 10px !important;
                                }
                          `}</style>
                        </Card>

                    })}</div>

            </div>

        )
    }
    allInputComponents = [];
    pushInputComponent = (inputComponent) => {
        if (inputComponent && this.allInputComponents) {
            let input = this.allInputComponents.find(input => input === inputComponent);
            if (!input) {
                this.allInputComponents.push(inputComponent);
            }
        }
    };

    getData = ()=>{
        this.request({
            url:  "/cm-sites-mmp/template/getIntegralTemplate",
            method: 'get',
            contentType: "json",
            callBack: (res) => {
                if(res){
                    this.state.current = res;
                    this.state.data = JSON.parse(res.configValue)
                }
               this.setState({})
            },
            errorCallBack: (e) => {
                message.error('操作失败！');
            },
        })
    };

    //校验
    checkRule = () => {
        let {dataSource,data} = this.state;
        let result = true;
        dataSource.forEach((i, index) => {
            i.inputs.forEach((item, i) => {
                if (item.props.empty) {
                    let field = item.props.field;
                    data.forEach((j)=>{
                        if(j.type === item.props.type){
                            if(!j[field]){
                                message.destroy();
                                message.warning(item.props.errorMessage);
                                result =false
                            }
                        }
                    });
                }
            })
        });
        return result;
    };

    edit = () =>{
        let checkResult = this.checkRule();
        if (!checkResult) {
            return false;
        }
        let {current} =this.state;
        current.configValue = JSON.stringify(this.state.data);
        this.request({
            url:  "/cm-sites-mmp/template/setIntegralTemplate",
            method: 'post',
            contentType: "json",
            body: current,
            loading:false,
            callBack: (res) => {
                if(res){
                    message.destroy();
                    message.success('保存成功,次日生效');
                    this.getData()
                }
            },
            errorCallBack: (e) => {
                message.error('操作失败！');
            },
        })
    }


}

